import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initGA, sanitizePath, trackPageView } from '../analytics'

export function GoogleAnalytics() {
    const location = useLocation()

    useEffect(() => {
        initGA()
        trackPageView(sanitizePath(location.pathname, location.search))
    }, [location])

    return null
}
